import api from "../apiConfig";

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  getAll(data) {
    let params = "";
    Object.keys(data ?? {}).forEach((key) => {
      if (data[key] !== null && data[key] !== "" && data[key] !== undefined) {
        params += `${key}=${data[key]}&`;
      }
    });
    return api.get(`/api/v1/leave-user?${params}`);
  },
  create(data) {
    return api.post(`/api/v1/leave-user`, data);
  },
  update(id, data) {
    return api.put(`/api/v1/leave-user/user-edit/${id}`, data);
  },
  // The rep cancelling their own request. `comments` is the backend's spelling.
  reject(id, data) {
    return api.put(`/api/v1/leave-user/user-reject/${id}`, data);
  },
};
